import format from "format-number";

export const formatNumber = format();

export const formatNumberDisplay = (
  value: number | string,
  isPercent?: boolean
) => {
  let valueText = value;
  if (typeof value === "number") {
    const formatedValue = isPercent ? Math.round(value * 10000) / 100 : value;

    if (formatedValue > 1000000000) {
      valueText = `${formatNumber(
        Math.round(formatedValue / 10000000) / 100
      )}B`;
    } else if (formatedValue > 10000000) {
      valueText = `${formatNumber(Math.round(formatedValue / 100000) / 10)}m`;
    } else if (formatedValue > 1000000) {
      valueText = `${formatNumber(Math.round(formatedValue / 10000) / 100)}m`;
    } else if (formatedValue > 100000) {
      valueText = `${formatNumber(Math.round(formatedValue / 1000))}k`;
    } else {
      valueText = formatNumber(formatedValue);
    }
  }
  return valueText;
};
